import React, { Fragment, useState, useRef, useEffect, useContext } from 'react';
import { object, func } from 'prop-types';
import { Card, Row, Col, List, Space, Typography, Divider, Avatar } from 'antd';
import { css } from '@emotion/core';
import { HashLink as Link } from 'react-router-hash-link';
import { useHistory } from 'react-router-dom';
import { getPublicSiteImageSrc } from 'Client/common/utils/AppUtils';
import { AppContext } from './../../Contexts/AppContext';

import './APIListCss.css';

const scrollWidthOffset = el => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  const yOffset = -220;
  window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
};

export const DropDownOverlayCss = css`
  width: 100%;
  margin: auto;
  top: 29px;
  box-shadow: 1px 1px 2px 2px lightgrey;

  .ant-card-body {
    padding: 0px 170px;
  }
    .active {
    color: #286CE2;
    font-family: Lato;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    }

  .btn__browse_all-first {
    float: left;
    font-family: Lato;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    text-align: left;
    color: #333333;
    }
.btn__browse_all-last {
  float: right;
  font-family: Lato !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 30px !important;
  text-align: left;
  color: #286CE2;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.btn__browse_all-last:hover,
.btn__browse_all-last:focus {
  text-decoration: none;
}
.btn__browse_all {
  float: center;
  font-family: Lato;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  text-align: left;
  color: #333333;
}
  .newReleaseImg {
    width: 294px;
    height: 189px;
  }

  .divider__vertical {
    height: 100%;
    border: 1px solid lightgrey;
  }

  .divider__horizontal {
    border-top: 1px solid lightgrey;
    margin: 15px 0;
  }

  .drpTitle {
    font: normal normal bold 14px/24px Montserrat;
    letter-spacing: 0px;
    color: #333333;
    opacity: 1;
  }
  .choose-api ul {
    padding: 0;
    display:block;
  }

  .responsive-placeholder-img {
    width: 100%;
    height: auto;
    max-width: 100%;

    @media (min-width: 576px) {
      width: 75%;
    }

    @media (min-width: 768px) {
      width: 75%;
    }
  }

  @media (min-width: 1300px) {
    width: 100%;
    .img__api {
      width: 70%;
      margin: 20px 45px;
    }
    .h4__heading {
      font: normal normal 600 12px/20px Montserrat;
      letter-spacing: 0px;
      color: #333333;
      opacity: 1;
    }
    .api__description_drp {
      font: normal normal normal 12px/18px Lato;
      letter-spacing: 0px;
      color: #666666;
      opacity: 1;
    }

    .api__title_section {
      padding-top: 12px;
    }
  }
  @media (min-width: 1600px) {
    width: 100%;
    .img__api {
      width: 70%;
    }
    .h4__heading {
      font: normal normal 600 14px/24px Montserrat;
      letter-spacing: 0px;
      color: #333333;
      opacity: 1;
    }
    .api__description_drp {
      font: normal normal normal 16px/24px Lato;
      letter-spacing: 0px;
      color: #666666;
      opacity: 1;
    }

    .api__title_section {
      padding-top: 12px;
    }
  }
`;

const getImageSrc = (apiName) => {
  return require(`./../../common/img/api-services/${apiName}_service.svg`).default;
};

const AgencyListComponent = props => {
  const { agencyApiData, closeDropDownHandler } = props;
 
  return (
    <Fragment>
      <Card
        bordered={false}
        className="card__api"
        title={<span className="drpTitle">{agencyApiData?.moduleTitle}</span>}
      >
        <List
          grid={{
            column: 1,
          }}
          dataSource={agencyApiData?.ListAssoc || []}
          renderItem={api => (
            <List.Item>
              <Link
                to={`/explore/api-service/agency_api#${api?.name}`}
                scroll={el => scrollWidthOffset(el)}
                onClick={closeDropDownHandler}
              >
                <Space direction="horizontal">
                  <div>
                    <img
                      className="img__api"
                      src={getImageSrc(api?.name)}
                      alt="img-api"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="api__title_section">
                    <Typography.Title className="h4__heading" level={4}>
                      {api?.heading}
                    </Typography.Title>
                    <Typography.Text level={4} className="api__description_drp">
                      {api?.title}
                    </Typography.Text>
                  </div>
                </Space>
              </Link>
            </List.Item>
          )}
        />
      </Card>
    </Fragment>
  );
};

AgencyListComponent.propTypes = {
  agencyApiData: object,
  closeDropDownHandler: func,
};

const CommercialListComponent = props => {
  const { commercialApiData, closeDropDownHandler } = props;

  return (
    <Fragment>
      <Card
        bordered={false}
        className="card__api"
        title={<span className="drpTitle">{commercialApiData?.moduleTitle}</span>}
      >
        <List
          grid={{
            column: 2,
          }}
          dataSource={commercialApiData?.ListAssoc || []}
          renderItem={api => (
            <List.Item>
              <Link
                to={`/explore/api-service/commercial_api#${api?.name}`}
                onClick={closeDropDownHandler}
                scroll={el => scrollWidthOffset(el)}
              >
                <Space direction="horizontal">
                  <span>
                    <img
                      className="img__api"
                      src={getImageSrc(api?.name)}
                      alt="img-api"
                      aria-hidden="true"
                    />
                  </span>
                  <span>
                    <Typography.Title className="h4__heading" level={4}>
                      {api?.heading}
                    </Typography.Title>
                    <Typography.Text level={4} className="api__description_drp">
                      {api?.title}
                    </Typography.Text>
                  </span>
                </Space>
              </Link>
            </List.Item>
          )}
        />
      </Card>
    </Fragment>
  );
};

CommercialListComponent.propTypes = {
  commercialApiData: object,
  navToDetailPage: func,
  closeDropDownHandler: func,
};

const DropdownOverlayComponent = props => {
  const history = useHistory();
  const { activeItem, onItemClick, agencyApiData, commercialApiData, navToOverviewPage, closeDropDownHandler } = props;

  const { wraSlotList } = useContext(AppContext);
  const mounted = useRef();
  const [state, setState] = useState({ data: {}, status: 'pending', error: null });
  const [bannerContent, setBannerContent] = useState({});

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      getOwcsContent();
    } 
  }, []);


  const getOwcsContent = () => {
    const banner_content = wraSlotList?.find(data => data?.name === 'banner_content_display') ?? [];

    setState({
      data: {
        banner_content,
      },
      status: wraSlotList ? 'success' : 'error',
    });

    setBannerContent(banner_content?.ListAssoc ? banner_content?.ListAssoc[0] : {});
  };

  const selectApi = item => {
    if (item) {
      closeDropDownHandler();
      history.push(`/explore/apiDetails/${item}`);
    }
  };
  const handleAPIItemClick = item => {
    onItemClick(item);
    setSelectedAPI(item);
  };
  
  const Services = {
    agency: [
      'Application List & Details',
      'Benefit Details',
      'Book of Business',
      'Broker News Feed',
      'Commissions',
      'Small Group Renewal Packet',
      'Coverage Document',
      'Opportunity Management',
      'Application Submission',
      'Application Status Pull Notification',
      'Group Structure',
      'Member Maintenance',
      'Document Upload',
      'Member Enrollment',
      'Quote Management',

    ],
    benefit: [
      'Book of Business',
      'Benefit Details',
      'Application Submission',
      'Group Structure',
      'Member Maintenance',
      'Member Enrollment',
      'Quote Management',
    ],
    techConnect: [
      'Book of Business',
      'Benefit Details',
      'Small Group Renewal Packet',
      'Coverage Document',
      'Application Submission',
      'Group Structure',
      'Member Maintenance',
      'Member Enrollment',
      'Quote Management',
    ],
    management: [
      'Commissions',
      'Book of Business',
      'Application List & Details',
      'Opportunity Management',
      'Benefit Details',
      'Broker News Feed',
      'Small Group Renewal Packet',
      'Coverage Document',
    ],
    commercial: [
      'Application Submission',
      'Application Status Pull Notification',
      'Group Structure',
      'Member Maintenance',
      'Member Enrollment',
      'Quote Management',
      'Document Upload',
    ],
  };
  const [selectedAPI, setSelectedAPI] = useState('agency');
  const handleClick = key => {
    // if (selectedAPI === 1) setSelectedAPI(0);
    // else setSelectedAPI(1);
    setSelectedAPI(key);
  };
  return (
    <Fragment>
      <Card bordered={false} css={DropDownOverlayCss}>
        <Row gutter={24}>
          {/* <Col span={6}>
            <AgencyListComponent agencyApiData={agencyApiData} closeDropDownHandler={closeDropDownHandler} />
          </Col>

          <Col span={18} style={{ borderLeft: '1px solid' }}>
            <CommercialListComponent
              commercialApiData={commercialApiData}
              closeDropDownHandler={closeDropDownHandler}
            />
          </Col> */}
          <Col span={6} className="chooseAPIBox">
            <div className="choose-api">
              <span className='choose-api-by-partner'>
                API BY PARTNER TYPE
              </span>
             <ul> 
              <li 
                onClick={() => handleAPIItemClick('agency')} 
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleAPIItemClick('agency'); } }}
                className={activeItem === 'agency' ? 'active' : ''}
                tabIndex={0}
              >
                For Agencies
              </li>
              <li 
                onClick={() => handleAPIItemClick('benefit')} 
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleAPIItemClick('benefit'); } }}
                className={activeItem === 'benefit' ? 'active' : ''}
                tabIndex={0}
              >
                Benefit Administrators
              </li>
              <li
                onClick={() => handleAPIItemClick('techConnect')}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleAPIItemClick('techConnect'); } }}
                className={activeItem === 'techConnect' ? 'active' : ''}
                tabIndex={0}
              >
                Technology Partners
              </li>
              </ul>
            </div>
            <div className="choose-api">
              <span className='choose-api-by-partner'>
                API By Business Case
              </span>
              <ul>
              <li
                onClick={() => handleAPIItemClick('management')}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleAPIItemClick('management'); } }}
                className={activeItem === 'management' ? 'active' : ''}
                tabIndex={0}
              >
                Agency Management
              </li>
              <li
                onClick={() => handleAPIItemClick('commercial')}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleAPIItemClick('commercial'); } }}
                className={activeItem === 'commercial' ? 'active' : ''}
                tabIndex={0}
              >
                Group & Member Management
              </li>
              </ul>
            </div>
          </Col>

          <Col span={12} style={{ borderLeft: '2px solid #99999933', paddingTop: 25, }}>
            <div className="col-2">
              
                <span className="apiServiceHeading">API SERVICES</span>
              
              <ul className='apiServiceBody'>
                {Services[selectedAPI].map((item, index) => {
                  return (
                    <li 
                      key={index}
                      className="partnerTypeAPIList" 
                      onClick={() => selectApi(item)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectApi(item); } }}
                      tabIndex={0}
                    >
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </Col>
          <Col span={6}>
         { bannerContent?.ListAssoc &&
            <div className="col-3 newReleaseSection">
              <Row justify="center" align="middle" gutter={[8, 16]}>
                <Col span={24}>
                  <div>
                    <span className="newReleaseHeading">New Release</span>
                  </div>
                </Col>
                <Col span={21}>
                  <div>
                    <img 
                      className="newReleaseImg" 
                      src={`/public/api/landing/fetch/${bannerContent?.ListAssoc && bannerContent?.ListAssoc[0]?.name}`}
                      alt="New Release"
                      aria-hidden="true"
                    />
                  </div>
                </Col>
                <Col span={20}>
                  <Row gutter={8} align="middle" className="brokerNewsHeading">
                    {/* <Col span={6} className="centered-col"> 
                      <img src={`/public/api/landing/fetch/${bannerContent?.ListAssoc[1]?.name}` }
                       className="responsive-placeholder-img"
                       alt="brokerNewsHeading"
                      />
                    </Col> */}
                    <Col span={24}>
                      <p style={{marginBottom:5 }}>
                        <b className="brokerNewsHeadTitle">{ bannerContent?.title }</b>
                      </p>
                    </Col>
                    <Col span={24}>
                      <div className="brokerNewsText">
                       { bannerContent?.description }
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          }
          </Col>
          {/* <ListOfApi></ListOfApi> */}
          <Col span={24}>
            <Divider className="divider__horizontal" plain type="horizontal" />
            <Row style={{ paddingBottom: 12 }} justify="end">
              <div >
                  <button className="btn__browse_all-last" onClick={navToOverviewPage}>
                    View All APIs
                  </button>
              </div>
              {/* <Col span={5}>
                <a className="btn__browse_all" onClick={navToOverviewPage}>
                  Popular APIs
                </a>
              </Col>
              <Col span={5}>
                <a className="btn__browse_all" onClick={navToOverviewPage}>
                  Notification APIs
                </a>
              </Col>
              <Col span={5}>
                <a className="btn__browse_all" onClick={navToOverviewPage}>
                  Application APIs
                </a>
              </Col>
              <Col span={4}>
                <a className="btn__browse_all-last" onClick={navToOverviewPage}>
                  Enrollment APIs
                </a>
              </Col> */}
            </Row>
          </Col>
        </Row>
      </Card>
    </Fragment>
  );
};

DropdownOverlayComponent.propTypes = {
  agencyApiData: object,
  commercialApiData: object,
  closeDropDownHandler: func,
  navToOverviewPage: func,
};

export default DropdownOverlayComponent;
